import { RightCircleOutlined } from '@ant-design/icons'
import { Collapse } from 'antd'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import './CollapseSingleCommon.scss'
const { Panel } = Collapse

export const CollapseSingleCommon = ({
	onChange,
	isOpen = true,
	header,
	children,
	type = 'default',
}) => {
	const handleChangeCb = () => {
		onChange && onChange()
	}

	return (
		<Collapse
			defaultActiveKey={isOpen ? ['1'] : undefined}
			onChange={handleChangeCb}
			className={classNames('collapse-single-common', `type-${type}`)}
			expandIcon={({ isActive }) => (
				<RightCircleOutlined rotate={isActive ? 90 : 0} />
			)}
			expandIconPosition="right"
		>
			<Panel header={header} key="1">
				{children}
			</Panel>
		</Collapse>
	)
}

CollapseSingleCommon.propTypes = {
	defaultActiveKey: PropTypes.array,
	onChange: PropTypes.func,
	items: PropTypes.array,
	type: PropTypes.oneOf(['default', 'light', 'transparent']),
}
